import { useTheme, type Breakpoint } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export const useIsMobileDevice = (breakpoint: number | Breakpoint = 'sm') => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.down(breakpoint));
};
